module.exports = __webpack_public_path__ + "img/logo_new.663ee430.png";